import React from 'react';

import E100TextField, { IPropTypes } from 'e100-react-components/lib/components/TextField';

import { useStyles } from './styles';

export const TextField = (props: IPropTypes) => {
  const classes = useStyles({ variant: props.variant });

  return (
    <E100TextField
      {...props}
      classes={{
        ...props.classes || {},
        root: classes.root
      }}
    />
  );
};
